var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.accountInfo.langByLanguage)?_c('div',{staticClass:"home-index"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }